import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import qs from "qs";
import * as Sentry from "@sentry/vue";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";

// export interface User {
//   name: string;
//   surname: string;
//   email: string;
//   password: string;
//   api_token: string;
// }

export type LoginUser = {
  id: string;
  username: string;
  full_name: string;
  clientid: string;
  type: number;
  status: number;
};

export interface UserAuthInfo {
  errors: unknown;
  user: LoginUser;
  isAuthenticated: boolean;
  clientid: string;
}

export type LoginResponse = {
  status: "OK" | "NOK";
  token?: string;
  data?: LoginUser;
  message?: string;
};

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = {};
  user = {} as LoginUser;
  isAuthenticated = !!JwtService.getToken();
  clientid = "";

  /**
   * Get current user object
   * @returns LoginUser
   */
  get currentUser(): LoginUser {
    return this.user;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors() {
    return this.errors;
  }

  get getClientid(): string {
    return this.clientid;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.SET_AUTH](data: LoginResponse) {
    // console.log("data", data);
    this.isAuthenticated = true;
    if (data.data) {
      this.clientid = data.data?.clientid;
      this.user = data.data;
      JwtService.saveClientId(data.data?.clientid ?? "");
      JwtService.saveUserType(data.data?.type ?? "");
      JwtService.saveUserData(data.data ?? {});
    }
    this.errors = {};
    JwtService.saveToken(data.token ?? "");
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
  }

  // @Mutation
  // [Mutations.SET_PASSWORD](password) {
  //   this.user.password = password;
  // }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as LoginUser;
    this.errors = [];
    JwtService.destroyToken();
    JwtService.destroyClientid();
    JwtService.destroyUsertype();
    JwtService.destroyUserData();
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  @Action
  [Actions.LOGIN](credentials) {
    // console.log(credentials);
    return ApiService.post<LoginResponse>(
      "/user/login",
      qs.stringify(credentials)
    )
      .then(({ data }) => {
        // console.log(data);
        if (data.status !== "OK") {
          // console.log("eror");
          this.context.commit(Mutations.SET_ERROR, { err: [data.message] });
        } else {
          setTimeout(() => {
            MenuComponent.reinitialization();
          }, 0);
          Sentry.setUser({ username: data?.data?.username });
          this.context.commit(Mutations.SET_AUTH, data);
        }
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.LOGOUT]() {
    const data = JSON.parse(JwtService.getUserData() || "{}");
    const param = {
      user_id: data.id,
    };
    return ApiService.post("/user/logout", qs.stringify(param)).then(
      ({ data }) => {
        if (data.status === "OK") {
          this.context.commit(Mutations.PURGE_AUTH);
        } else {
          console.log(data.status);
        }
      }
    );
  }

  @Action
  [Actions.REGISTER](credentials) {
    return ApiService.post("register", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.FORGOT_PASSWORD](payload) {
    return ApiService.post("user/request_reset_password", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.VERIFY_AUTH](payload) {
    console.log(payload);
    // if (JwtService.getToken()) {
    //   ApiService.setHeader();
    //   ApiService.post("verify_token", payload)
    //     .then(({ data }) => {
    //       this.context.commit(Mutations.SET_AUTH, data);
    //     })
    //     .catch(({ response }) => {
    //       this.context.commit(Mutations.SET_ERROR, response.data.errors);
    //       this.context.commit(Mutations.PURGE_AUTH);
    //     });
    // } else {
    //   this.context.commit(Mutations.PURGE_AUTH);
    // }
  }
}
